import { Box, CardContent, Stack } from '@mui/material';
import { startCase } from 'lodash';

import { Text, api, isDefined } from 'common';

import { MAX_TEMPLATE_NAME_DISPLAY_LENGTH } from '../constants';
import { FlowTemplateCardBranding } from './Branding';
import { FlowTemplateCardDecoration } from './Decoration';
import { FlowTemplateCardUseCaseIcon } from './Icons/UseCaseIcon';

const TemplateTagCategory = api.FlowDefinitionTemplate.TagCategory;

interface FlowTemplateCardContentProps {
  flowTemplate: Pick<
    api.FlowDefinitionTemplate.FlowDefinitionTemplate,
    'name' | 'tags' | 'content' | 'organizationId'
  >;
}

export function FlowTemplateCardContent(props: FlowTemplateCardContentProps) {
  const {
    flowTemplate: { name, tags, content, organizationId },
  } = props;

  const useCaseTag = tags?.find((tag) => tag.category === TemplateTagCategory.UseCase)?.name;
  const solutionAreaTag = tags?.find(
    (tag) => tag.category === TemplateTagCategory.SolutionArea
  )?.name;

  return (
    <>
      <FlowTemplateCardDecoration solutionArea={solutionAreaTag} />
      <CardContent
        sx={{
          width: '100%',
        }}
      >
        <Stack gap={2}>
          <Stack direction="row" gap={2}>
            <Stack gap={0.5}>
              {isDefined(useCaseTag) && (
                <Text variant="subtitle2" color="text.secondary" bold>
                  {startCase(useCaseTag)}
                </Text>
              )}
              <Text
                variant="heading5"
                bold
                sx={{
                  maxHeight: '60px',
                  overflow: 'hidden',
                  display: '-webkit-box',
                  WebkitBoxOrient: 'vertical',
                  WebkitLineClamp: 2,
                }}
              >
                {name.length > MAX_TEMPLATE_NAME_DISPLAY_LENGTH
                  ? `${name.slice(0, MAX_TEMPLATE_NAME_DISPLAY_LENGTH)}...`
                  : name}
              </Text>
            </Stack>
            <Box sx={{ marginLeft: 'auto' }}>
              <FlowTemplateCardUseCaseIcon useCase={useCaseTag} solutionArea={solutionAreaTag} />
            </Box>
          </Stack>
          <Text
            variant="body2"
            sx={{
              color: 'grey.600',
              maxHeight: '64px',
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
            }}
          >
            {content}
          </Text>
          <FlowTemplateCardBranding organizationId={organizationId} />
        </Stack>
      </CardContent>
    </>
  );
}
